import { createContext, useContext, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  DARK_THEME_PRESETS,
  DEFAULT_PURPLE_PRESET,
  DEFAULT_THEME_KEY,
} from "./config/theme.presets";

const DynamicThemeContext = createContext();

export function DynamicThemeProvider({ children }) {
  const [colors, setColors] = useState(DEFAULT_PURPLE_PRESET);

  useEffect(() => {
    const active = localStorage.getItem("active_theme") || DEFAULT_THEME_KEY;

    const preset =
      active === DEFAULT_THEME_KEY
        ? DEFAULT_PURPLE_PRESET
        : DARK_THEME_PRESETS[active];

    if (preset) {
      setColors(preset);
    }
  }, []);

  const theme = createTheme({
    palette: {
      mode: "light",
      primary: { main: colors.primary },
      secondary: { main: colors.secondary },
    },

    sidebar: {
      bgStart: colors.sidebarBgStart,
      bgEnd: colors.sidebarBgEnd,
      active: colors.active,
      hover: colors.hover,
      logoutHover: colors.logoutHover,
    },

    genz: {
      gradient: `linear-gradient(90deg, ${colors.genzGradientStart}, ${colors.genzGradientMid}, ${colors.genzGradientEnd})`,
    },

    avatarGradients_1: {
      avatarStart: colors.primary,
      avatarCenter: colors.primary,
      avatarEnd: colors.primary,
    },

    avatarGradients_2: {
      avatarStart: colors.primary,
      avatarCenter: colors.primary,
      avatarEnd: colors.primary,
    },

    avatarGradients_3: {
      avatarStart: colors.primary,
      avatarCenter: colors.primary,
      avatarEnd: colors.primary,
    },

    actionStyles: {
      view: {
        bgcolor: `${colors.primary}22`,
        color: colors.primary,
        border: `1px solid ${colors.primary}55`,
      },
      create: {
        bgcolor: `${colors.primary}22`,
        color: colors.primary,
        border: `1px solid ${colors.primary}55`,
      },
      update: {
        bgcolor: `${colors.primary}22`,
        color: colors.primary,
        border: `1px solid ${colors.primary}55`,
      },
      delete: {
        bgcolor: `${colors.logoutHover}22`,
        color: colors.logoutHover,
        border: `1px solid ${colors.logoutHover}55`,
      },
    },

    actionStyles_form_bg_active: {
      view: colors.primary,
      create: colors.primary,
      update: colors.primary,
      delete: colors.primary,
    },

    actionStyles_form_color_active: {
      view: "#ffffff",
      create: "#ffffff",
      update: "#ffffff",
      delete: "#ffffff",
    },

    actionStyles_form_borderColor: {
      view: `${colors.primary}55`,
      create: `${colors.primary}55`,
      update: `${colors.primary}55`,
      delete: `${colors.primary}55`,
    },

    roleColors: {
      superadmin: colors.primary,
      admin: colors.primary,
      manager: colors.primary,
      user: colors.primary,
      employee: colors.primary,
    },

    headers: { primary: colors.primary },
  });

  return (
    <DynamicThemeContext.Provider value={{ setColors }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </DynamicThemeContext.Provider>
  );
}

export const useThemeColors = () => useContext(DynamicThemeContext);
